import { createLogic } from 'redux-logic';
import {
    stepDialogUpdate,
    stepDialogUpdated,
    stepDialogStatePrepare,
    stepDialogOpen,
    stepChoicesUpdate,
    stepDialogSave,
    nextStepsUpdate,
} from '../actions';

const removeCurrStep = (getState, allSteps) => {
    const currStep = allSteps[getState().formFinderBuilder.activeStep];
    return allSteps.filter((step) => step !== currStep);
};

const convertNextStepsForSave = (getState) => {
    const nextSteps = getState().stepDialog.nextSteps;
    const allSteps = getState().formFinderBuilder.steps;
    const stepsWithoutCurr = removeCurrStep(getState, allSteps);
    if (nextSteps.length > 0) {
        return nextSteps.map((row) => allSteps.indexOf(stepsWithoutCurr[row.step]));
    } else {
        return [];
    }
};

const prepareStepDialogState = createLogic({
    type: stepDialogStatePrepare,
    latest: true,
    warnTimeout: 0,
    process({ getState, action }, dispatch) {
        const step = action.payload;
        let nextSteps = [];
        if (step.choices) {
            const allSteps = getState().formFinderBuilder.steps;
            const filteredSteps = removeCurrStep(getState, allSteps);
            nextSteps = action.payload.choices.map((choice) => {
                const continueWithObject = allSteps[choice.continueWith];
                return {
                    choice: choice.choice,
                    step: filteredSteps.indexOf(continueWithObject),
                };
            });
        }
        dispatch(stepDialogOpen({ step, nextSteps }));
    },
});

const updateStepDialog = createLogic({
    type: stepDialogUpdate,
    latest: true,
    warnTimeout: 0,
    process({ getState, action }, dispatch) {
        const oldStep = getState().stepDialog.step;

        const step = {
            ...oldStep,
            ...action.payload,
        };
        dispatch(stepDialogUpdated({ step }));
    },
});

const updateNextSteps = createLogic({
    type: nextStepsUpdate,
    latest: true,
    process({ action }, dispatch, done) {
        const nextSteps = action.payload;
        dispatch(stepDialogUpdated({ nextSteps }));
        dispatch(stepDialogSave());
        done();
    },
});

const updateStepChoices = createLogic({
    type: stepChoicesUpdate,
    latest: true,
    warnTimeout: 0,
    process({ getState, action }, dispatch) {
        let nextChoices;
        if (action.payload.value) {
            const prevChoices = getState().stepDialog.step.choices;
            nextChoices = [
                ...prevChoices.slice(0, action.payload.index),
                {
                    ...prevChoices[action.payload.index],
                    ...action.payload.value,
                },
                ...prevChoices.slice(action.payload.index + 1),
            ];
        } else {
            nextChoices = getState().stepDialog.step.choices.filter((choice, index) => index !== action.payload.index);
        }

        const step = {
            ...getState().stepDialog.step,
            choices: nextChoices,
        };
        dispatch(stepDialogUpdated({ step }));
    },
});

const saveStepDialog = createLogic({
    type: stepDialogSave,
    latest: true,
    warnTimeout: 0,
    process({ getState }, dispatch) {
        let step = getState().stepDialog.step;
        const stepOptions = convertNextStepsForSave(getState);
        if (step.choices && step.choices.length > 0) {
            const newChoices = step.choices.map((choice, index) => {
                return {
                    ...choice,
                    continueWith: stepOptions[index],
                };
            });
            step = {
                ...step,
                choices: newChoices,
            };
        }
        dispatch(stepDialogUpdated({ step }));
    },
});

export default [updateStepDialog, updateStepChoices, prepareStepDialogState, saveStepDialog, updateNextSteps];
